export default class ResponseSystemError extends Error {
  constructor(err) {
    super();
    this.name = 'ResponseSystemError';
    this.errors = err;
  }
}
